export default "__VITE_ASSET__72f3cbaa__"